module.exports = __webpack_public_path__ + "img/ic_launcher@3x.3759620d.png";